/**
 * Thresholds for displaying toolbox buttons.
 */
export const BUTTONS_THRESHOLDS = [
    {
        width: 880,
        order: [
            'desktop',
            'audioOnly',
            'chat',
            'security',
            'microphone',
            'camera',
            'noisesuppression',
            'tileview',
            'invite',
            'participants',
            'virtualBackgroundCircle',
        ],
    },
    {
        width: 720,
        order: [
            'desktop',
            'audioOnly',
            'chat',
            'security',
            'microphone',
            'camera',
            'noisesuppression',
            'invite',
            'tileview',
            'participants',
            'cameraFlip',
            'virtualBackgroundCircle',
        ],
    },
    {
        width: 565,
        order: [
            'chat',
            'microphone',
            'camera',
            'noisesuppression',
            'tileview',
            'cameraFlip',
        ],
    },
    {
        width: 200,
        order: ['chat', 'microphone', 'camera', 'cameraFlip', 'tileview'],
    },
];
